import {z} from '@hono/zod-openapi';

import {advertisingMappingStatsWindowSchema} from './AdvertisingMappingStatsWindowSchema';

export const advertisingMappingStatsQuerySchema = z
  .object({
    window: advertisingMappingStatsWindowSchema.default('24h'),
  })
  .openapi('AdvertisingMappingStatsQuery');
